import { RefreshTokenRequestModel } from './refresh-token.request.model';

export class RefreshTokenRequestMessage {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  RefreshTokenRequestMessage!: RefreshTokenRequestModel;
}
